import styled from "styled-components";
import { Table, Icon, Modal, Col, Radio } from "antd";
import { GhostButtonComponent } from "../../../../CommonComponents/commonStyles";

export const ColSpacing = styled(Col)`
  margin-left: 20px;
  @media (max-width: 991px) {
    margin-left: 0px;
  }
`;

export const AlignItems = styled.div`
  align-items: center;
  justify-content: space-between;
  /* width: 750px; */
  @media only screen and (max-width: 767px) {
    display: block;
    width: 320px;
  }
`;

export const CheckboxWrapper = styled.div`
  margin-left: 25px;
  @media only screen and (max-width: 767px) {
    margin-top: 20px;
  }
`;

export const CheckboxLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.25;
  letter-spacing: ${props => props.theme.letterSpacing.point7};
  color: ${props => props.theme.colors.dropdownArrow};
`;

export const PoolTable = styled(Table)`
  .ant-table {
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr {
        background-color: #ffffff;
        border-top: solid 1px #d4d4d4;
        border-bottom: solid 1px #d4d4d4;
      }
      & > tr > th {
        color: ${props => props.theme.fontColors.thead};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
      }
    }
    .ant-table-thead > tr > th {
      padding: 16px 10px;
    }
    .ant-table-tbody {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      & > tr > td {
        padding: 19.5px 10px;
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        color: ${props => props.theme.fontColors.tbody};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
      }
    }
    .ant-table-column-title {
      transform: none;
    }
  }
`;

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row:nth-child(2n + 1) {
    background-color: ${props =>
      props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-input-number {
    width: 100% !important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-table-footer {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 0;
    border-bottom: solid 1px #9b9b9b;
    height: 80px;
    @media only screen and (max-width: 767px) {
      height: auto;
    }
  }
`;

export const ExchangeToTable = styled(PoolTable)`
  &&& {
    //margin-top: 3rem;
    .ant-table .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    }
    .ant-table .ant-table-header colgroup col:first-child,
    .ant-table .ant-table-body colgroup col:first-child {
      display: none;
    }
    .ant-table-thead > tr:first-child > th:first-child {
      display: none;
    }
    border-bottom: solid 1px #bfbfbf;
  }
  .ant-table .ant-table-tbody .ant-table-row:nth-child(1) {
    height: 5rem;
    &:hover {
      background-color: white;
    }
    td {
      font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
      font-size: ${props => props.theme.fontSize.h4};
      letter-spacing: ${props => props.theme.letterSpacing.point7};
      color: ${props => props.theme.fontColors.headingColor};
      padding: 30px 10px;
      @media only screen and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.heading};
      }
    }
  }
  .ant-table-row:nth-child(2n) {
    background-color: ${props =>
      props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-table-footer {
    background-color: #fff;
    border-bottom: solid 1px #9b9b9b;
    height: 80px;
    align-items: center;
    > div {
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      height: auto;
    }
  }
`;

export const BackIcon = styled(Icon)`
  display: inline-block;
  position: relative;
  transition: left 0.2s;
  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const BackButton = styled(GhostButtonComponent)`
  &:hover ${BackIcon} {
    left: -5px;
  }
`;

export const NavigationBtnContainer = styled.div`
  justify-content: space-between;
  & > div {
    display: flex;
    & button:nth-child(1) {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 991.92px) {
    flex-flow: wrap;
    & > button > span {
      font-size: 18px;
      font-weight: 900;
      font-style: normal;
      font-stretch: condensed;
      line-height: 1.67;
      letter-spacing: 1.1px;
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
    }
    & > button:first-child {
      flex-basis: 100%;
      margin-top: 39px;
    }
    & > button {
      flex-basis: 100%;
      margin-top: 20px;
    }
  }
`;

export const FromNavigationBtnContainer = styled(NavigationBtnContainer)``;

export const ToNavigationBtnContainer = styled(NavigationBtnContainer)``;

export const FromTableFooter = styled.div`  
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  align-items: center;  
`;
export const FromTableFooterCol = styled.div`
  padding: 19.5px 10px;
  width: calc(100% - 294px);
  @media only screen and (min-width: 992px) and (max-width: 1030px) {
    width: calc(100% - 220px);
  }
`

export const ToTableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  & > div:nth-child(1) {
    flex-grow: 0.75;
  }
  & > div:nth-child(2) {
    flex-grow: 0.25;
  }
`;

const FromToTableFooter = styled.div`
  border-top: solid 2px ${props => props.theme.border.raeCardFooter};
  border-bottom: solid 2px ${props => props.theme.border.raeCardFooter};
  padding: 0.75rem 0;
  color: ${props => props.theme.fontColors.raeCardFooter};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.pont5};
  & > div {
    margin-bottom: 0.25rem;
  }
`;

export const FromCardFooter = styled(FromToTableFooter)``;

export const ToCardFooter = styled(FromToTableFooter)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1024px) {
    margin: 0 -25px;
    padding: 0.75rem 1.5625rem;
  }
  @media (max-width: 576px) {
    margin: 0 -20px;
    padding: 0.75rem 1.25rem;
  }
`;

export const Flex = styled.div`
  display: flex;
`;

export const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media only screen and (max-width: 990px) {
    flex-direction: column;        
    margin: 0 -15px 0 0;
    width: 100%;
    button{
      margin: 15px 15px 0 0;
    }
    div{
      margin: 0 -15px 0 0;
    }
  }
`;


export const PillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 71px;
  height: 23px;
  margin-left: 15px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  p {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: 1.63;
    padding-left: 0.25rem;
    margin: 3px 0 0 0;
  }

  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;

export const TotalFixedText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 0.6px;
  font-size: 12px;
`;

export const InvestmentOptionFixGridVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: normal;
  text-transform: capitalize;
`;

export const ErrorMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: red;
`;
export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
    font-style: normal;
    font-stretch: normal;
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    text-align: center;
  }

  .ant-modal-footer {
    padding: 6px 16px 16px 16px;
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 292px;
    border-radius: 0;
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #fff;
    background-color: #006778;
    @media only screen and (min-width: 320px) and (max-width: 374px) {
      width: 252px;
    }
  }

  .ant-modal-footer button + button {
    @media only screen and (min-width: 320px) and (max-width: 347px) {
      margin-left: 0;
    }
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff!;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #006778;
    border: 0px solid transparent;
    text-decoration: underline;
    &:focus {
      box-shadow: 0 0 0 0.15rem #006778;
    }
  }
  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: #006778;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn-primary:focus {
    box-shadow: 0 0 0 0.15rem #006778;
  }
`;

export const PoolModal = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: #505050;
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
  }
  .ant-modal-header {
    padding: 30px 0 13px 0;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    padding: 24px 48px 30px 33px;
    text-align: center;
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: #006778;
    border: 0px solid transparent;
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: #006778;
    text-decoration: underline;
  }
`;

export const CustomRadio = styled(Radio)`
  .ant-radio-inner::after {
    background-color: #006778;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #006778;
  }

  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #006778;
  }
`;

export const RecommendAnExchangeWrapper = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
`;

export const RecommendAnExchangeHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: ${props => props.theme.lineHeight.h1};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-style: normal;
  font-stretch: normal;
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: ${props => props.theme.lineHeight.h2};
    margin-bottom: 1.5rem;
  }
`;
